import { Component, Input } from '@angular/core';
import { Patient } from '../patient';
import { AuthService } from '../../service/auth.service';
import { faAddressCard, faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { faUserMd } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mc-patient-list',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.scss']
})
export class PatientListComponent {

  calendarAlt = faCalendarAlt;
  addressCard = faAddressCard;
  userMd = faUserMd;

  @Input() public patients: Patient[];

  constructor(private authService: AuthService) { }
}
